import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

import Button from "../../components/common/Button/Button";
import FormInput from "../../components/common/FormInput/FormInput";
import { showToast } from "../../components/common/ToastNotification/ToastNotification";

import { getCustompageId, updateCustom } from "../../api/service/custompage.service";

const UpdateCustomPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [menuId, setMenuId] = useState("");

  useEffect(() => {
    const fetchPageDetails = async () => {
      try {
        const response = await getCustompageId(id);
        console.log(response,"response//////")
        if (response?.data) {
          const page = response.data;
          setTitle(page.title || "");
          setSlug(page.slug || "");
          setDescription(page.description || "");
          setMenuId(page.menu_id || "");
        }
      } catch (error) {
        console.error("Fetch Error:", error);
        showToast.error("Failed to load custom page details.");
      }
    };

    if (id) fetchPageDetails();
  }, [id]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    console.log("Form values before submission:");
    console.log("title:", title);
    console.log("slug:", slug);
    console.log("description:", description);
    console.log("menuId:", menuId);

    if (!title) {
      showToast.error("Please enter title");
      return;
    }

    try {
      setLoading(true);

      const submitData = {
        page_id: id,
        menu_id: menuId,
        slug: slug || "",
        title: title,
        description: description
      };

      console.log("JSON data being submitted:", submitData);

      const response = await updateCustom(submitData);

      console.log("API Response:", response);

      if (response.success) {
        showToast.success(response.message);
        navigate("/menu");
      } else {
        showToast.error(response.message || "Update failed");
      }
    } catch (error) {
      console.error("Update Error:", error);
   showToast.success(error.message);
      // showToast.error("Failed to update custom page");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="management-tile mb-0">Update Custom Page</h3>
      </div>

      <form onSubmit={handleUpdate}>
        <Row>
          <Col xs={12} className="mb-3">
            <label className="form-label">Title</label>
            <FormInput
              value={title}
              placeholder="Enter title"
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">Description</label>
            <FormInput
              type="textarea"
              value={description}
              placeholder="Page description"
              onChange={(e) => setDescription(e.target.value)}
            />
          </Col>

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Page"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default UpdateCustomPage;